import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

export default class extends Controller {
  static get values() { return { url: String, notification: String }; }

  dismiss(event) {
    event.preventDefault();
    this.element.style.display = "none";

    // JSON content type is load-bearing: the action reads params[:notification] straight off the
    // body, which fetch does not parse into params unless it is announced as JSON.
    const options = RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify({ notification: this.notificationValue });

    fetch(this.urlValue, options).catch(this.logFailedCall);
  }

  logFailedCall(response) {
    console.warn(response);
  }
}
